import { useSuspenseQuery } from '@apollo/client';
import { useSearchingStore } from '../store/useSearchStore';
import { useList } from './useList';
import {
  FetchSearchPageQuery,
  FetchSearchPageQueryVariables,
  QUERY_SEARCH_FETCH_PAGE,
  ResourceType,
  SearchPage,
} from '@edwin-group/cj-graphql';
import { SearchItem } from '../../../types/types';
import { useEffect } from 'react';

export const useRoot = () => {
  const { setSearchPage } = useSearchingStore();
  const { missionsList, programmesList, resourcesList, coursesList, loadingMore, onFetchMore, canLoadMore } = useList();

  const { data } = useSuspenseQuery<FetchSearchPageQuery, FetchSearchPageQueryVariables>(QUERY_SEARCH_FETCH_PAGE, {
    fetchPolicy: 'cache-first',
  });

  useEffect(() => {
    if (data?.searchPage) {
      setSearchPage(data?.searchPage as SearchPage, data.resourceTypes as ResourceType[]);
    }
  }, [data, setSearchPage]);

  function intercalate(...arrays: (Array<SearchItem> | null | undefined)[]): Array<SearchItem> {
    const validArrays = arrays.filter((arr): arr is Array<SearchItem> => Array.isArray(arr));

    if (validArrays.length === 0) return [];

    const maxLength = Math.max(...validArrays.map((arr) => arr.length));
    const result: Array<SearchItem> = [];

    for (let i = 0; i < maxLength; i++) {
      for (const arr of validArrays) {
        if (arr[i]) {
          result.push(arr[i]);
        }
      }
    }

    return result;
  }

  const searchData = intercalate(
    missionsList?.nodes as SearchItem[],
    programmesList as SearchItem[],
    resourcesList as SearchItem[],
    coursesList as SearchItem[],
  );

  return {
    searchData,
    loadingMore,
    onFetchMore,
    canLoadMore,
  };
};
